/* eslint-disable no-debugger */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */
import React, { Component } from 'react';

import {
  Container,
  Grid,
  Typography,
  Button,
  styled,
  Stack,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from '@mui/material';
import _ from 'lodash';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import ReactPlaceholder from 'react-placeholder/lib';
import { connect } from 'react-redux';
import { Breadcrumbs } from 'wae_rwlb_reactlibrary';
import XLSX from 'xlsx';

import { addMultipleItemToCart, loadUploadExcelData, resetUploadData } from '../../actions';
import { Table } from '../../components';
import { breadcrumbNameMap } from '../../helpers/config';
import { formatAmount } from '../../helpers/functions';
import UploadPlaceholder from './UploadPlaceholder';

const columnsConfig = t => [
  {
    field: 'col1',
    headerName: t('uploadScreenTranslations:MATERIAL'),
    key: 'Material',
    width: 150,
    flex: 1,
  },
  {
    field: 'col2',
    headerName: 'Requested Quantity',
    key: 'ConditionQuantity',
    width: 150,
    flex: 1,
  },
  {
    field: 'col5',
    headerName: 'Stock Quantity',
    key: 'StockQuantity',
    width: 150,
    flex: 1,
    renderCell: params => {
      return (
        <Typography variant="subtitle1" component="h2">
          {params.row.col5 !== undefined && params.row.col5 !== '' ? params.row.col5 : '-'}
        </Typography>
      );
    },
  },
  {
    field: 'col6',
    headerName: 'Price',
    key: 'SalesPrice',
    width: 150,
    flex: 1,
    renderCell: params => {
      return (
        <Typography variant="subtitle1" component="h2">
          {formatAmount('en-AE', params.value, params.row.col7)}
        </Typography>
      );
    },
  },
  {
    field: 'col3',
    headerName: 'Total Amount',
    key: 'subTotal',
    width: 150,
    flex: 1,
    renderCell: params => {
      return (
        <Typography variant="subtitle1" component="h2">
          {formatAmount('en-AE', params.value, params.row.col7)}
        </Typography>
      );
    },
  },
  {
    field: 'col4',
    headerName: t('uploadScreenTranslations:STATUS'),
    key: 'AvailableStock',
    minWidth: 150,
    flex: 1,
    renderCell: params => {
      const isMaterialNotAvailable = params.row.col5 === undefined;
      const isNotAvailable = params.row.col5 !== undefined && params.row.col5 < params.row.col2;
      const isAvailable = params.row.col5 !== undefined && params.row.col5 > params.row.col2;
      return (
        <Typography variant="subtitle1" component="h2" color={isAvailable ? 'green' : 'error'}>
          {isAvailable && t('uploadScreenTranslations:AVAILABLE')}
          {isNotAvailable && 'Out of Stock'}
          {isMaterialNotAvailable && 'Material Not Available'}
          {/* // TODO: Move to i18n  */}
        </Typography>
      );
    },
  },
  {
    field: 'col7',
    headerName: 'Currency',
    key: 'SalesPriceUnit',
    hideFromHeader: true,
    hideFromFilter: true,
    // width: 150,
    // flex: 1,
  },
];

const Input = styled('input')({
  display: 'none',
});
const errorMsgText = 'uploadScreenTranslations:MSG2';
class Upload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRows: [],
      isError: false,
      page: 0,
      rowsPerPage: 20,
      skip: 0,
      open: false,
      excelData: [],
      fileName: '',
      filterStr: '',
      openDupPopup: false,
      dupData: [],
      filteredData: [],
    };
  }

  async componentDidMount() {
    try {
      this.props.resetUploadData([]);
    } catch (err) {
      console.log(err);
    }
  }

  handleAddToCart = () => {
    const { t, upload } = this.props;
    const { uploadData } = upload;
    try {
      const { selectedRows } = this.state;

      const list = [];
      if (uploadData.length > 0) {
        uploadData.forEach((l, index) => {
          if (selectedRows.some(s => s === index)) {
            const {
              Material,
              MaterialName,
              MaterialGrossWeight,
              ConditionQuantity,
              SalesPrice,
              SalesPriceUnit,
              StockQuantityUOM,
              StockQuantity,
              Tax,
            } = l;

            if (SalesPrice > 0) {
              const res = {
                Material,
                qty: parseInt(ConditionQuantity, 10),
                MaterialName,
                Price: SalesPrice,
                Currency: SalesPriceUnit,
                ConditionQuantity,
                MaterialGrossWeight,
                available: true,
                StockQuantityUOM,
                StockQuantity,
                Tax,
              };
              list.push(res);

              this.props.enqueueSnackbar(t('uploadScreenTranslations:MSG1'), {
                variant: 'success',
              });
            } else {
              this.props.enqueueSnackbar(t('uploadScreenTranslations:MSG2'), {
                variant: 'error',
              });
            }
          }
        });
        this.props.addMultipleItemToCart(list);
        this.setState({ selectedRows: [] });
        const uData = [];
        this.props.resetUploadData(uData);
      }
    } catch (err) {
      this.props.enqueueSnackbar(t(errorMsgText), { variant: 'error' });
      console.log(err);
    }
  };

  fileReader = async oEvent => {
    const { t } = this.props;

    try {
      this.setState({ selectedRows: [] });
      const oFile = oEvent.target.files[0];
      const fileType = oFile.name.split('.');
      if (fileType[1] === 'xlsx') {
        const reader = new FileReader();
        // const itemsData = [];
        reader.onload = e => {
          try {
            let data = e.target.result;
            data = new Uint8Array(data);

            const workbook = XLSX.read(data, { type: 'array' });

            const result = {};
            result.Sheet1 = XLSX.utils.sheet_to_json(workbook.Sheets.Sheet1, {
              header: 1,
            });

            const sheet1 = result.Sheet1;
            const c1 = sheet1[0][0];
            const c2 = sheet1[0][1];
            // const c3 = sheet1[0][2];
            // const c4 = sheet1[0][3];
            // const c5 = sheet1[0][4];

            sheet1.shift();
            let obj = {};
            let excelData = [];
            sheet1.map(s => {
              obj[c1] = s[0];
              obj[c2] = s[1];
              // obj[c3] = s[2];
              // obj[c4] = s[3];
              // obj[c5] = s[4];
              excelData.push(obj);
              obj = {};
              return s;
            });
            let dupData = [];

            dupData = excelData.filter(item => {
              const isDup = excelData.filter(el => el.Material === item.Material).length > 1;
              return isDup;
            });
            dupData = _.uniqBy(dupData, 'Material');

            if (dupData.length > 0) {
              excelData = excelData.filter(
                item => dupData.find(l => l.Material === item.Material) === undefined
              );
            }
            excelData = [...excelData, ...dupData];
            let filterArr = [];
            let filterStr = '';
            filterArr = excelData.map(l => `Material eq '${l.Material}'`);
            filterStr = filterArr.join(' or ');
            if (dupData.length > 0) {
              this.setState({ openDupPopup: true, dupData });
            } else if (excelData.length <= 100) {
              this.props.loadUploadExcelData(
                this.props.enqueueSnackbar,
                filterStr,
                excelData,
                oFile.name
              );
            } else {
              this.setState({ open: true, excelData, fileName: oFile.name, filterStr });
            }
          } catch (err) {
            this.props.enqueueSnackbar(t(errorMsgText), {
              variant: 'error',
            });
            console.log(err);
            this.setState({ isError: true });
          }
        };
        reader.readAsArrayBuffer(oFile);
      } else {
        this.props.enqueueSnackbar(t('uploadScreenTranslations:MSG3'), {
          variant: 'error',
        });
      }
    } catch (err) {
      this.props.enqueueSnackbar(t(errorMsgText), {
        variant: 'error',
      });
      console.log(err);
    }
  };

  onSelectionModelChange = s => {
    this.setState({ selectedRows: s });
  };

  onChangeBrowseInput = e => {
    this.fileReader(e);
    e.target.value = '';
  };

  saveFilterData = fData => {
    this.setState({ filteredData: fData });
  };

  s2ab = s => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < s.length; i++) {
      // eslint-disable-next-line no-bitwise
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  };

  handleDownloadSampleFormat = () => {
    const formattedData = [{ Material: '', ConditionQuantity: '' }];

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const excelBlob = new Blob(
      [this.s2ab(XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' }))],
      {
        type: 'application/octet-stream',
      }
    );

    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(excelBlob);
    downloadLink.download = 'Sampleformatteddata.xlsx';

    downloadLink.click();
  };

  handlePageChange = async (e, value) => {
    try {
      const { rowsPerPage } = this.state;
      const { t, upload } = this.props;
      const { uploadData } = upload;
      const skip1 = value * rowsPerPage;
      const uData = uploadData.filter((u, index) => index < rowsPerPage + skip1 && index >= skip1);
      const data = uData.map((o, index) => {
        let row = { id: index };
        columnsConfig(t).forEach(k => {
          row = {
            ...row,
            [k.field]: o[k.key],
          };
        });
        return row;
      });

      this.setState({ page: value, skip: skip1, filteredData: data });

      window.scrollTo(0, 0);
    } catch (err) {
      console.log(err);
    }
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleContinue = () => {
    const { filterStr, excelData, fileName, dupData } = this.state;
    const data = excelData.filter((l, index) => index < 100);

    this.setState({ excelData: data });
    this.props.loadUploadExcelData(this.props.enqueueSnackbar, filterStr, data, fileName);
    this.setState({ open: false, openDupPopup: false });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  render() {
    const {
      selectedRows,
      isError,
      page,
      rowsPerPage,
      filteredData,
      skip,
      open,
      dupData,
      openDupPopup,
    } = this.state;
    const { t, upload } = this.props;
    const { uploadData, isLoading } = upload;
    const isErrorText = !isError
      ? t('uploadScreenTranslations:MSG4')
      : t('uploadScreenTranslations:MSG5');
    const uData = uploadData.filter((u, index) => index < rowsPerPage + skip && index >= skip);

    return (
      <Container>
        <Breadcrumbs {...this.props} breadcrumbNameMap={breadcrumbNameMap(t)} />
        <Grid container direction="row" justifyContent="center" sx={{ marginY: 6 }}>
          <Grid item xs={12} sm={12} md={12}>
            <Grid
              item
              container
              direction="row"
              justifyContent="space-between"
              style={{ marginBottom: 10 }}
            >
              <Grid
                item
                container
                direction="row"
                justifyContent="flex-start"
                xs={6}
                alignItems="center"
              >
                <Button
                  variant="contained"
                  color="primary"
                  disabled={uploadData.length === 0 || selectedRows.length === 0}
                  onClick={this.handleAddToCart}
                  sx={{
                    fontSize: { xs: 10, sm: 12, md: 14 },
                  }}
                >
                  {t('uploadScreenTranslations:ADD_TO_CART')}
                </Button>
              </Grid>
              <Grid
                item
                container
                direction="row"
                justifyContent="flex-end"
                xs={6}
                alignItems="center"
              >
                <Stack direction="row" spacing={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    onClick={this.handleDownloadSampleFormat}
                    sx={{
                      fontSize: { xs: 10, sm: 12, md: 14 },
                    }}
                  >
                    {t('uploadScreenTranslations:DOWNLOAD_SAMPLE_FORMAT')}
                  </Button>
                  <label htmlFor="contained-button-file">
                    <Input
                      accept="xlxs/*"
                      id="contained-button-file"
                      multiple
                      type="file"
                      onChange={this.onChangeBrowseInput}
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      component="span"
                      sx={{
                        fontSize: { xs: 10, sm: 12, md: 14 },
                      }}
                    >
                      {t('uploadScreenTranslations:BROWSE')}
                    </Button>
                  </label>
                </Stack>
              </Grid>
            </Grid>
            <ReactPlaceholder
              showLoadingAnimation
              ready={!isLoading}
              customPlaceholder={<UploadPlaceholder />}
            >
              <Box my={6}>
                {uploadData.length > 0 ? (
                  <Table
                    checkboxSelection
                    columnsConfig={columnsConfig(t)}
                    data={uData}
                    isRowSelectable={params =>
                      params.row.col2 <= params.row.col5 &&
                      params.row.col3 > 0 &&
                      params.row.col6 > 0
                    }
                    onSelectionModelChange={this.onSelectionModelChange}
                    selectionModel={selectedRows}
                    rowsPerPage={rowsPerPage}
                    listCount={uploadData.length}
                    page={page}
                    saveFilterData={fData => this.saveFilterData(fData)}
                    filteredData={filteredData}
                    t={this.props.t}
                    onPageChange={this.handlePageChange}
                  />
                ) : (
                  <Stack justifyContent="center" m={6}>
                    <Typography variant="h5" alignSelf="center">
                      {isErrorText}
                    </Typography>
                  </Stack>
                )}
              </Box>
            </ReactPlaceholder>
            <Dialog
              open={open}
              onClose={this.handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">Maximum upload limit reached</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Maximum upload limit at once is 100 records, click Continue to upload first 100
                  records.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose}>Cancel</Button>
                <Button variant="contained" onClick={this.handleContinue} autoFocus>
                  Continue
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog
              open={openDupPopup}
              onClose={this.handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">Duplicate Records Found</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Please remove duplicate records mentioned below and try upload again.
                </DialogContentText>
                {dupData.map(d => (
                  <DialogContentText id="alert-dialog-description">{d.Material}</DialogContentText>
                ))}
              </DialogContent>
              <DialogActions>
                <Button onClick={() => this.setState({ openDupPopup: false })}>Close</Button>
                {/* <Button variant="contained" onClick={this.handleContinue} autoFocus>
                  Close
                </Button> */}
              </DialogActions>
            </Dialog>
          </Grid>
        </Grid>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return { cart: state.cart, product: state.product, upload: state.upload };
};
const cUpload = connect(mapStateToProps, {
  addMultipleItemToCart,
  loadUploadExcelData,
  resetUploadData,
})(Upload);
const tUpload = withTranslation(['uploadScreenTranslations'])(cUpload);
const sUpload = withSnackbar(tUpload);
export { sUpload as Upload };
